export enum NsKey {
  Common = 'common',
  ActorForm = 'actorForm',
  Mandate = 'mandate',
  Contractualization = 'contractualization',
  Pricing = 'pricing',
  Profiling = 'profiling',
  Borrower = 'borrower',
  RealEstate = 'realEstate',
  Risk = 'risk',
  Quote = 'quote',
  Contract = 'contract',
  Document = 'document',
  Product = 'product',
  Note = 'note',
  MncapMedicalValidation = 'mncapMedicalValidation',
  IdentityUpload = 'identityUpload',
  PersonneMorale = 'personneMorale',
  Validation = 'validation'
}
